"use client";
import { ArrowRight, Play } from "lucide-react";
import { motion } from "framer-motion";
import HeroLottie from "./HeroLottie";

/* Reveal on page load: the left column staggers its children top-to-bottom,
   while each item rises from below + fades in. */
const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

const rise = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

const HeroSection = () => {
  //grid remove use this
  /***
   *       style={{
          backgroundImage:
            "linear-gradient(to right, rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.04) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          WebkitMaskImage: "linear-gradient(to bottom, black, transparent 80%)",
          maskImage: "linear-gradient(to bottom, black, transparent 80%)",
        }}
   */
  return (
    <section
      style={{
        backgroundColor: "#F5F5F7",
        backgroundImage:
          "radial-gradient(58.91% 76.39% at 80% -10%, rgba(127, 161, 255, 0.18) 0%, rgba(127, 174, 255, 0.00) 60%), radial-gradient(58.91% 62.5% at -5% 30%, rgba(69, 85, 237, 0.14) 0%, rgba(69, 88, 237, 0.00) 55%), url(/assets/hero/grid.svg)",
        backgroundPosition: "0 0, 0 0, 0 -90px",
      }}
      className="relative w-full overflow-hidden min-h-[calc(100vh-280px)] lg:min-h-[calc(100vh-120px)] flex items-center pt-10 lg:pt-12"
    >
      <div className="w-full px-6 md:px-[40px] xl:px-20 2xl:px-[100px] 3xl:px-[120px]  4xl:px[140px]">
        <motion.div
          className="relative z-10 w-full  lg:max-w-[640px] 3xl:max-w-[820px] 4xl:max-w-[960px]"
          variants={container}
          initial="hidden"
          animate="show"
        >
          <div className="block absolute top-0 left-0 z-[-1] w-[462px] h-[621px] bg-zinc-100 rounded-full blur-[107.63px]" />

          <motion.div
            variants={rise}
            className="mb-5 mt-2 xs:mt-10 lg:mt-0 inline-flex items-center gap-2 font-kalam font-medium shadow-sm h-7 3xl:h-8 4xl:h-9 rounded-full border border-color-grey-8-10%/10 bg-white px-3 py-1 text-xs 3xl:text-sm 4xl:text-base text-[#53555C]"
          >
            <span className="inline-flex items-center justify-center bg-[#7F7FFF]/20 rounded-full w-2 h-2 lg:w-3.5 lg:h-3.5 shrink-0">
              <span className="block w-1 h-1 lg:w-1.5 lg:h-1.5 rounded-full bg-[#7F7FFF]" />
            </span>

            <span className="leading-none whitespace-nowrap font-bold italic">
              AI Ad Operating system
            </span>
          </motion.div>

          <motion.h1 variants={rise} className="hero-heading">
            Stop
            <span className="relative text-[#53555C] pl-3 font-semibold">
              guessing
              <hr className="bg-[#53555C] border-none -rotate-1 h-1 absolute top-1/2 left-2 w-[95%]" />
            </span>
            <br />
            what ads work.
            <br />
            Start
            <span className="text-[#3232AA] font-normal lg:italic pl-3">
              running
            </span>{" "}
            a
            <br />
            system.
          </motion.h1>

          <motion.p
            variants={rise}
            className="body-text-hero w-full max-w-[529px] md:max-w-[400px] lg:max-w-[400px] xl:max-w-[500px] 3xl:max-w-[550px] 4xl:max-w-[700px] "
          >
            Imagive.ai connects creative generation, analysis, optimization, and
            scaling into one continuous system, so every campaign gets smarter
            over time.
          </motion.p>

          <motion.div
            variants={rise}
            className="mt-10 md:mt-8 flex flex-col sm:flex-row   items-start sm:items-center gap-3"
          >
            <button className="btn-primary  w-full md:w-auto  justify-center inline-flex group  font-medium items-center gap-2">
              <a
                href="https://app.imagive.ai?redirect=/users/competitive-analysis"
                target="_blank"
                className=" flex items-center gap-2 "
              >
                Start creating ads
                <ArrowRight
                  size={18}
                  className="group-hover:translate-x-1 transition-transform duration-300 "
                />
              </a>
            </button>
            {/* <button className="btn-secondary group w-full  justify-center      md:w-auto font-medium inline-flex items-center gap-2">
              <a
                href="https://app.imagive.ai/"
                target="_blank"
                className=" flex items-center gap-2 "
              >
                <Play
                  size={16}
                  className="group-hover:scale-110  transition-transform duration-300 "
                />
                See how it works
              </a>
            </button> */}
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        className="pointer-events-none absolute right-0 top-[55%] hidden -translate-y-1/2 md:block"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.9, delay: 0.5, ease: "easeOut" }}
      >
        <div className="w-[800px] md:translate-x-[65%] lg:translate-x-[45%] xl:w-[1000px] xl:translate-x-[25%] 3xl:w-[1280px] 4xl:w-[1600px]">
          <div className="top-[70px] 3xl:top-[90px] 4xl:top-[110px] w-44 3xl:w-56 4xl:w-64 z-10 px-4 py-3 -left-10 absolute bg-gradient-to-l from-indigo-950 to-indigo-800 rounded-tl-xl rounded-tr-xl rounded-bl-xl inline-flex justify-start items-center gap-2">
            <div className="w-36 3xl:w-44 4xl:w-52 inline-flex flex-col justify-start items-start text-[#FBFAF7] text-xs 3xl:text-sm 4xl:text-base font-normal leading-4 3xl:leading-5">
              Your complete toolkit for
              <span className="font-semibold">performance creative</span>
              workflows.
            </div>
            <div className="w-5 h-5 left-[-6px] top-[-6px] absolute bg-indigo-800 rounded-[29.76px] outline outline-2 outline-offset-[-1.83px] outline-gray-100 overflow-hidden">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.916667"
                  y="0.916667"
                  width="20.1667"
                  height="20.1667"
                  rx="10.0833"
                  fill="#3232A1"
                />
                <rect
                  x="0.916667"
                  y="0.916667"
                  width="20.1667"
                  height="20.1667"
                  rx="10.0833"
                  stroke="#F4F4F7"
                  strokeWidth="1.83333"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.27888 10.9582L9.0385 8.67934H9.50466L10.2643 10.9582L12.5432 11.7178V12.184L10.2643 12.9436L9.50466 15.2225H9.0385L8.27888 12.9436L6 12.184V11.7178L8.27888 10.9582Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.5783 7.88717L12.9694 6.71387H13.4356L13.8267 7.88717L15 8.27827V8.74442L13.8267 9.13552L13.4356 10.3088H12.9694L12.5783 9.13552L11.405 8.74442V8.27827L12.5783 7.88717Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>

          <div className="overflow-hidden rounded-2xl shadow-2xl">
            <HeroLottie />
          </div>
        </div>
      </motion.div>
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-[#F5F5F7]" />
    </section>
  );
};

export default HeroSection;
